// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  flex-grow: 1;
  width: ${(props: Object) => (props.fullWidth ? '100%' : '50%')};
  margin-left: 13px;
  margin-right: 10px;
  margin-top: 10px;
  border-right: 1px dashed #ccc;
  padding-left: ${(props: Object) => (props.leftPadding ? '10px' : '0')};

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
    border-right: none;
  }
`

const Title: StyledComponent<Object, any, any> = styled.div`
  font-size: 15px;
  padding-bottom: 10px;
  padding-left: 2px;
  color: #000;
  font-weight: bold;
`

type Props = {|
  title?: string,
  children: any,
  leftPadding?: boolean,
  fullWidth?: boolean
|}

export default function Column(props: Props) {
  const { title, children, leftPadding, fullWidth } = props

  return (
    <Wrapper fullWidth={fullWidth} leftPadding={leftPadding}>
      {title && <Title>{title}</Title>}
      {children}
    </Wrapper>
  )
}
